export default __webpack_public_path__ + "static/media/gallery-35.8c18f90d.jpg";